export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';